import React, { Fragment } from "react";
import LinkImg from "Assets/images/file-type/other-types.svg";
import useStyles from "./styles";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import VideoDefaultImage from "Assets/images/file-type/video.svg";
import { Box } from "@material-ui/core";
import ReactPlayer from "react-player";

const DisplayVideoLink = ({ url, isDashboard = false }) => {
  const classes = useStyles();
  const youtubeRegex = /(?:youtu\.be\/|\/videos\/|embed\/|\/v\/|\/e\/|watch\?v=|&v=|embed\/watch\?v=|embed\/v\/|youtu.be\/v\/|embed\/e\/|watch\?feature=player_embedded&v=)([a-zA-Z0-9_-]+)/;
  // /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
  const vimeoRegex =
    /(?:http|https)?:?\/?\/?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;

  const getYoutubeThumbnail = url => {
    let video_id;
    const result = url.match(youtubeRegex).filter(i => i);
    if (result.length || url.match()) {
      video_id = result.pop();
    }
    if (video_id) {
      return `http://i.ytimg.com/vi/${video_id}/mqdefault.jpg`;
    }
  };

  const getVimeoThumbnail = url => {
    let video_id;
    const result = url.match(vimeoRegex).filter(i => i);
    if (result.length || url.match()) {
      video_id = result.pop();
    }
    if (video_id) {
      return `https://vumbnail.com/${video_id}.jpg`;
    }
  };

  const getVideoThumbnail = url => {
    let imageUrl = VideoDefaultImage;
    if (url.match(youtubeRegex)) {
      imageUrl = getYoutubeThumbnail(url);
    } else if (new RegExp(vimeoRegex, "g").test(url)) {
      imageUrl = getVimeoThumbnail(url);
    } else {
      imageUrl = LinkImg;
    }
    return <img src={imageUrl}></img>;
  };

  return (
    <Box
      height="100%"
      width="100%"
      className={`${classes.videoThumbnail} video-thumb`}>
      {isDashboard ? (
        <Fragment width="100%" height="100%">
          {getVideoThumbnail(url)}
          <span className={classes.playIcon}>
            <PlayArrowIcon />
          </span>
        </Fragment>
      ) : (
        <ReactPlayer url={url} controls={true} width="100%" height={"100%"} />
      )}
    </Box>
  );
};

export default DisplayVideoLink;
